import { render, staticRenderFns } from "./BusinessPulseReport.vue?vue&type=template&id=1cba0064"
import script from "./BusinessPulseReport.vue?vue&type=script&lang=js"
export * from "./BusinessPulseReport.vue?vue&type=script&lang=js"
import style0 from "./BusinessPulseReport.vue?vue&type=style&index=0&id=1cba0064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports